import { Provider } from '@angular/core';

import { APP_STORE } from '@stores/app.store';
import { USER_STORE } from '@stores/user.store';

export const STORE_PROVIDERS: Provider[] = [APP_STORE, USER_STORE];
